import { useEffect, useRef, useState } from 'react';
import { ReactComponent as DropdownArrowDown } from '../../../assets/icons/dropdownArrowDown.svg';
import { ReactComponent as DropdownUpArrow } from '../../../assets/icons/dropdownArrowUp.svg';
import styles from './customDropdown.module.css';

const CustomDropdown = ({
    options = [],
    label,
    value,
    onChange,
    placeholder,
    disabled = false,
    required,
    className
}) => {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={`${styles.customDropdown} ${className}`} ref={dropdownRef}>
            {label && (
                <div className={styles.customDropdownLabel}>
                    <label htmlFor=''>{label}</label>
                </div>
            )}
            <div className={styles.customDropdownInput} onClick={() => setIsOpen((Prev) => !Prev)}>
                <div className={styles.customDropdownInputDiv}>
                    <span className={styles.customDropdownInputDivValue}>{value && value.label}</span>
                    <div className={styles.customDropdownInputDivArrow}>
                        {isOpen ? <DropdownUpArrow /> : <DropdownArrowDown />}
                    </div>
                </div>
            </div>
            {isOpen && Array.isArray(options) && options.length > 0 && (
                <div className={styles.customDropdownOptions}>
                    {options.map((option) => {
                        const isSelected = option?.id === value?.id;
                        return (
                            <div
                                key={option.id}
                                className={styles.customDropdownOptionLabel}
                                onClick={() => {
                                    onChange(option);
                                    setIsOpen(false);
                                }}
                            >
                                <span>{option.label}</span>
                                <input type='radio' name='customDropdown' checked={isSelected} readOnly />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;
